import type { FC, PropsWithChildren } from "react";
import { memo } from "react";
import { Footer, Header } from "@src/components";
import { StyledLayout } from "./layout.styles";
import { useLocation } from "react-router-dom";

export const FullLayout: FC<PropsWithChildren> = memo(({ children }) => {
  const { pathname } = useLocation();
  return (
    <>
      <Header />
      <StyledLayout pathname={pathname}>
        <main>{children}</main>
      </StyledLayout>
      <Footer />
    </>
  );
});
